'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyId$() {
  this.c7U = null;
  this.c7V = false;
  this.c7S = null;
  this.c7T = false;
}
export { $c_Lpresto_types$PolicyId$ as $c_Lpresto_types$PolicyId$ };
$p = $c_Lpresto_types$PolicyId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyId$;
/** @constructor */
function $h_Lpresto_types$PolicyId$() {
}
export { $h_Lpresto_types$PolicyId$ as $h_Lpresto_types$PolicyId$ };
$h_Lpresto_types$PolicyId$.prototype = $p;
$p.cHC = (function() {
  if ((!this.c7V)) {
    this.c7U = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.c7V = true;
  }
  return this.c7U;
});
$p.Gt = (function() {
  if ((!this.c7T)) {
    this.c7S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c7T = true;
  }
  return this.c7S;
});
var $d_Lpresto_types$PolicyId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyId$, "presto.types$PolicyId$", ({
  a1b: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyId$ as $d_Lpresto_types$PolicyId$ };
var $n_Lpresto_types$PolicyId$;
function $m_Lpresto_types$PolicyId$() {
  if ((!$n_Lpresto_types$PolicyId$)) {
    $n_Lpresto_types$PolicyId$ = new $c_Lpresto_types$PolicyId$();
  }
  return $n_Lpresto_types$PolicyId$;
}
export { $m_Lpresto_types$PolicyId$ as $m_Lpresto_types$PolicyId$ };
//# sourceMappingURL=presto.types$-Policy-Id$.js.map
